import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';
import './skodaRadioIcons.scss';

export const SkodaRadioIcon: React.FC<SvgIconProps> = (props) =>
    <SvgIcon {...props}>
        <path d="M0 12a12 12 0 1024 0a12 12 0 10-24 0M2 12a10 10 0 1120 0a10 10 0 11-20 0 M6,12a6,6 0 1,0 12,0a6,6 0 1,0 -12,0" />
    </SvgIcon>;

export const SkodaRadioBlankIcon: React.FC<SvgIconProps> = (props) =>
    <SvgIcon {...props}>
        <path d="M0 12a12 12 0 1024 0a12 12 0 10-24 0M2 12a10 10 0 1120 0a10 10 0 11-20 0" />
    </SvgIcon>;

export const SkodaRadioCheckerIcon: React.FC<SvgIconProps> = (props) =>
    <SvgIcon {...props}>
        <path d="M6,12a6,6 0 1,0 12,0a6,6 0 1,0 -12,0" />
    </SvgIcon>;

export const SkodaRadioAnimatedIcon: React.FC<SvgIconProps> = (props) =>
    <div className={'skoda-animated-radio'}>
        <SkodaRadioBlankIcon {...props} className={'skoda-animated-radio-blank'} />
        <SkodaRadioCheckerIcon {...props} className={'skoda-animated-radio-checker'} />
    </div>;
